import { __assign, __awaiter, __extends, __generator, __read, __spreadArray, __values } from "tslib";
import React, { Component } from 'react';
// Utils.
import { orderBy, sortBy } from 'lodash';
import { productListCategorySort } from './constants/productSort';
import { FilterIcon } from './images/svg/FilterIcon';
// Components.
import InfinityList from './InfinityList';
import { StyleBean } from './models/Beans';
import ProductListItem from './ProductListItem';
import StickyHeader from './StickyHeader';
import ProductListStickyTitle from './ProductListStickyTitle';
import { readProductGridView, writeProductGridView, plClassName, wrapperClassName, isEditorialHalfItem, } from './utils/productGridView';
import { pushStickyTitle, popStickyTitle, resetStickyTitles } from './stickyTitleStore';
import { uniq } from 'lodash';
// import { groupBy } from '../src/utils/UtilHelper';
var groupBy = function (key) { return function (array) {
    return array.reduce(function (objectsByKeyValue, obj) {
        var value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});
}; };
var ProductList = /** @class */ (function (_super) {
    __extends(ProductList, _super);
    function ProductList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingItems = false;
        _this.state = {
            order: null,
            productOverlayComponent: null,
            showModal: false,
            filteredStyles: [],
            productSortedByCategory: new Map(),
            groupedBySeason: new Map,
            showFilter: false,
            selectedDeliveryWindow: undefined,
            selectedSustainability: [],
            listIndex: 0,
            products: [],
            infiniteLoaderCurrentIndex: 0,
            chunked: [[]],
            currentCategory: '',
            elements: [],
            hasMore: true,
            firstInitialized: false,
            gridViewMode: readProductGridView(),
        };
        _this.handleOnChangeProduct = function (item) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.handleOnChangeProduct && this.props.handleOnChangeProduct(item);
                return [2 /*return*/];
            });
        }); };
        _this.handleOnProductClick = function (product) {
            if (_this.props.handleOnProductClick) {
                _this.props.handleOnProductClick(product);
            }
        };
        _this.hide = function () { };
        _this.applyBasketChanges = function (changes) { };
        _this.applyChanges = function () { };
        _this.goBack = function () { };
        _this.isInBasket = function (product) {
            if (!_this.props.isInBasket)
                return false;
            return _this.props.isInBasket(product);
        };
        _this.onSticky = function (categoryName) {
            pushStickyTitle(categoryName);
        };
        _this.onUnSticky = function (categoryName) {
            popStickyTitle(categoryName);
        };
        _this.handleGridViewChange = function (mode) {
            writeProductGridView(mode);
            _this.setState({ gridViewMode: mode });
        };
        _this.updateItems = function () {
            var iterator1 = _this.state.productSortedByCategory.keys();
            _this.setState({
                hasMore: true,
                elements: [],
                currentCategory: iterator1.next().value,
                // currentCategory: Object.keys(this.state.productSortedByCategory).sort().reverse()[0],
                infiniteLoaderCurrentIndex: 0
            }, function () {
                _this.loadItems();
            });
        };
        _this.loadItems = function () {
            if (_this.loadingItems || !_this.state.hasMore) {
                return;
            }
            if (_this.state.currentCategory !== '') {
                _this.loadingItems = true;
                var elements = [];
                // let productSortedByCategory = this.getProductCategories(this.state.filteredStyles);
                var currentCategory = _this.state.currentCategory;
                var infiniteLoaderCurrentIndex = _this.state.infiniteLoaderCurrentIndex;
                var counter = 0;
                var hasMore = true;
                while (counter < 100) {
                    if (!_this.state.productSortedByCategory.has(currentCategory)) {
                        counter = 100;
                        hasMore = false;
                        break;
                    }
                    var styles = _this.state.productSortedByCategory.get(currentCategory);
                    var nextElement = styles && styles[infiniteLoaderCurrentIndex] ? styles[infiniteLoaderCurrentIndex] : undefined;
                    if (nextElement) {
                        if (infiniteLoaderCurrentIndex === 0) {
                            var header = { description: currentCategory };
                            elements.push({
                                type: 'iheader',
                                header: header,
                            });
                        }
                        var product = nextElement;
                        elements.push({
                            type: "style",
                            style: product
                        });
                        counter++;
                        infiniteLoaderCurrentIndex++;
                    }
                    else {
                        infiniteLoaderCurrentIndex = 0;
                        var keys = __spreadArray([], __read(_this.state.productSortedByCategory.keys()), false);
                        currentCategory = keys[(keys.indexOf(currentCategory) + 1)];
                    }
                }
                _this.setState({
                    hasMore: hasMore,
                    elements: __spreadArray(__spreadArray([], __read(_this.state.elements), false), __read(elements), false),
                    currentCategory: currentCategory,
                    infiniteLoaderCurrentIndex: infiniteLoaderCurrentIndex
                }, function () {
                    _this.loadingItems = false;
                });
            }
            else {
                _this.loadingItems = false;
            }
        };
        return _this;
    }
    ProductList.prototype.componentDidUpdate = function (prevProps) {
        var e_1, _a, e_2, _b, e_3, _c;
        var _this = this;
        if (this.props.products) {
            var products = __spreadArray([], __read(this.props.products), false);
            if ((this.props.products && this.props.products.length !== prevProps.products.length
                ||
                    (!this.state.firstInitialized && this.props.products.length))) {
                var productSortedByCategory = this.getProductCategories(products);
                var groupedBySeason = new Map();
                try {
                    for (var productSortedByCategory_1 = __values(productSortedByCategory), productSortedByCategory_1_1 = productSortedByCategory_1.next(); !productSortedByCategory_1_1.done; productSortedByCategory_1_1 = productSortedByCategory_1.next()) {
                        var _d = __read(productSortedByCategory_1_1.value, 2), key = _d[0], value = _d[1];
                        var groupBySeasonCode = groupBy(['seasonCode']);
                        var gbs = groupBySeasonCode(value);
                        var sortKeys = [];
                        var years = uniq(Object.keys(gbs).map(function (seasonCode) { return seasonCode.substring(1); }));
                        try {
                            for (var _e = (e_2 = void 0, __values(years.sort().reverse())), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var year = _f.value;
                                if (Object.keys(gbs).indexOf('W' + year) !== -1) {
                                    sortKeys.push('W' + year);
                                }
                                if (Object.keys(gbs).indexOf('S' + year) !== -1) {
                                    sortKeys.push('S' + year);
                                }
                                if (Object.keys(gbs).indexOf('N' + year) !== -1) {
                                    sortKeys.push('N' + year);
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        var mappedInSeasonOrder = new Map();
                        try {
                            for (var sortKeys_1 = (e_3 = void 0, __values(sortKeys)), sortKeys_1_1 = sortKeys_1.next(); !sortKeys_1_1.done; sortKeys_1_1 = sortKeys_1.next()) {
                                var delta = sortKeys_1_1.value;
                                mappedInSeasonOrder.set(delta, orderBy(gbs[delta], ['masterId'], ['asc']));
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (sortKeys_1_1 && !sortKeys_1_1.done && (_c = sortKeys_1.return)) _c.call(sortKeys_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        groupedBySeason.set(key, mappedInSeasonOrder);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (productSortedByCategory_1_1 && !productSortedByCategory_1_1.done && (_a = productSortedByCategory_1.return)) _a.call(productSortedByCategory_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                this.setState({
                    filteredStyles: __assign({}, products),
                    productSortedByCategory: productSortedByCategory,
                    groupedBySeason: groupedBySeason,
                    firstInitialized: true
                }, function () {
                    _this.updateItems();
                });
            }
        }
    };
    ProductList.prototype.getProductCategories = function (styles) {
        var e_4, _a, e_5, _b, e_6, _c;
        var categories = {};
        var collectionName = this.props.collectionName;
        if (!styles.length)
            return new Map();
        try {
            for (var styles_1 = __values(styles), styles_1_1 = styles_1.next(); !styles_1_1.done; styles_1_1 = styles_1.next()) {
                var style = styles_1_1.value;
                if (!categories[style.productCategory] && style.productCategory.trim() !== '') {
                    categories[style.productCategory] = [];
                }
                if (style.productCategory.trim() !== '') {
                    categories[style.productCategory].push(style);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (styles_1_1 && !styles_1_1.done && (_a = styles_1.return)) _a.call(styles_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        for (var i in categories) {
            categories[i] = orderBy(categories[i], ['masterId'], ['asc']);
        }
        var keysNotInSort = [];
        var keysInSort = [];
        var inCat = {};
        var productMap = new Map();
        // let notInCat: ICategory = {};
        var allowedCollections = ['ow', 'main', 'sport', 'swim'];
        if (allowedCollections.indexOf(collectionName.toLowerCase()) === -1) {
            collectionName = 'no-collection';
        }
        if (collectionName === 'no-collection') {
            // return categories
            for (var categoryName in categories) {
                productMap.set(categoryName, categories[categoryName]);
            }
            return productMap;
        }
        if (productListCategorySort[collectionName.toLowerCase()]) {
            keysNotInSort = Object.keys(categories)
                .filter(function (key) { return productListCategorySort[collectionName.toLowerCase()].indexOf(key) === -1 && key.toLowerCase() !== 'marketing'; });
            keysInSort = Object.keys(categories)
                .filter(function (key) { return productListCategorySort[collectionName.toLowerCase()].indexOf(key) !== -1 && key.toLowerCase() !== 'marketing'; });
            keysInSort = sortBy(keysInSort, function (item) {
                return productListCategorySort[collectionName.toLowerCase()].indexOf(item);
            });
        }
        try {
            for (var keysInSort_1 = __values(keysInSort), keysInSort_1_1 = keysInSort_1.next(); !keysInSort_1_1.done; keysInSort_1_1 = keysInSort_1.next()) {
                var categoryName = keysInSort_1_1.value;
                inCat[categoryName] = categories[categoryName];
                productMap.set(categoryName, categories[categoryName]);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (keysInSort_1_1 && !keysInSort_1_1.done && (_b = keysInSort_1.return)) _b.call(keysInSort_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        try {
            for (var keysNotInSort_1 = __values(keysNotInSort), keysNotInSort_1_1 = keysNotInSort_1.next(); !keysNotInSort_1_1.done; keysNotInSort_1_1 = keysNotInSort_1.next()) {
                var categoryName = keysNotInSort_1_1.value;
                productMap.set(categoryName, categories[categoryName]);
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (keysNotInSort_1_1 && !keysNotInSort_1_1.done && (_c = keysNotInSort_1.return)) _c.call(keysNotInSort_1);
            }
            finally { if (e_6) throw e_6.error; }
        }
        if (categories['Marketing']) {
            productMap.set('Marketing', categories['Marketing']);
        }
        return productMap;
    };
    ProductList.prototype.componentWillUnmount = function () {
        resetStickyTitles();
    };
    ProductList.prototype.renderCategory = function (styles, categoryName) {
        var _this = this;
        if (!styles.length) {
            return null;
        }
        return (React.createElement(React.Fragment, { key: categoryName },
            React.createElement(StickyHeader, { title: categoryName, onSticky: this.onSticky, onUnSticky: this.onUnSticky }),
            React.createElement("ul", { className: plClassName(this.state.gridViewMode) }, styles && styles.map(function (product, index) {
                return React.createElement("li", { key: index, onClick: function () { return _this.handleOnProductClick(product); }, className: wrapperClassName(_this.state.gridViewMode, index) },
                    React.createElement(ProductListItem, { product: StyleBean.build(product, 'style'), discount: _this.props.lineDiscount, inBasket: _this.isInBasket(product), lazyLoadMoloMaster: _this.props.lazyLoadMoloMaster, quantityLabel: 'Available', getPrice: _this.props.getPrice, showQuantity: !!_this.props.showQuantity, showSoldQuantity: _this.props.showSoldQuantity, baseUrl: _this.props.baseUrl, imageUrlForProduct: _this.props.imageUrlForProduct, handleShowStyleOrders: _this.props.handleOnShowStyleOrdersClick, imageProfile: isEditorialHalfItem(_this.state.gridViewMode, index)
                            ? 'large'
                            : 'thumb' }));
            }))));
    };
    ProductList.prototype.renderCategoryBySeasonCodes = function (seasons, categoryName) {
        var _this = this;
        return (React.createElement(React.Fragment, { key: categoryName },
            React.createElement(StickyHeader, { title: categoryName, onSticky: this.onSticky, onUnSticky: this.onUnSticky }),
            React.createElement("ul", { className: plClassName(this.state.gridViewMode) }, (function () {
                var productIndex = 0;
                return __spreadArray([], __read(seasons.keys()), false).map(function (key) {
                    var styles = seasons.get(key);
                    return styles && styles.map(function (product) {
                        var itemIndex = productIndex;
                        productIndex += 1;
                        return (React.createElement("li", { key: product.masterId + product.colorCode + itemIndex, onClick: function () { return _this.handleOnProductClick(product); }, className: wrapperClassName(_this.state.gridViewMode, itemIndex) },
                            React.createElement(ProductListItem, { product: StyleBean.build(product, 'style'), discount: _this.props.lineDiscount, inBasket: _this.isInBasket(product), lazyLoadMoloMaster: _this.props.lazyLoadMoloMaster, quantityLabel: 'Available', getPrice: _this.props.getPrice, showQuantity: !!_this.props.showQuantity, showSoldQuantity: _this.props.showSoldQuantity, baseUrl: _this.props.baseUrl, imageUrlForProduct: _this.props.imageUrlForProduct, handleShowStyleOrders: _this.props.handleOnShowStyleOrdersClick, imageProfile: isEditorialHalfItem(_this.state.gridViewMode, itemIndex)
                                    ? 'large'
                                    : 'thumb' })));
                    });
                });
            })())));
    };
    ProductList.prototype.render = function () {
        var _this = this;
        if (this.props.simple) {
            return (React.createElement("div", { className: "product-list--simple" },
                React.createElement("div", { className: "product-list__content" },
                    React.createElement("div", { className: "product-list__list" },
                        React.createElement("div", { className: "product-list__list", id: "sticky-container" }, React.createElement("ul", { className: plClassName(this.state.gridViewMode) }, this.props.products && this.props.products.map(function (product, index) {
                            return React.createElement("li", { key: index, onClick: function () { return _this.handleOnProductClick(product); }, className: wrapperClassName(_this.state.gridViewMode, index) },
                                React.createElement(ProductListItem, { product: StyleBean.build(product, 'style'), discount: _this.props.lineDiscount, inBasket: _this.isInBasket(product), lazyLoadMoloMaster: _this.props.lazyLoadMoloMaster, quantityLabel: 'Available', showBarcode: _this.props.showBarcode, showSoldQuantity: _this.props.showSoldQuantity, baseUrl: _this.props.baseUrl, imageUrlForProduct: _this.props.imageUrlForProduct, handleShowStyleOrders: _this.props.handleOnShowStyleOrdersClick, imageProfile: isEditorialHalfItem(_this.state.gridViewMode, index)
                                        ? 'large'
                                        : 'thumb' }));
                        })))))));
        }
        return (React.createElement("div", { className: "product-list" + (!!this.props.showFilter ? " filter-is-active" : "") },
            React.createElement(ProductListStickyTitle, { gridViewMode: this.state.gridViewMode, onGridViewChange: this.handleGridViewChange }),
            React.createElement("div", { className: "product-list__content" },
                !this.props.ignoreFilter && this.props.filterComponent,
                !this.props.useInfiniteScroll && !this.props.simple &&
                    React.createElement("div", { className: "product-list__list", id: "sticky-container" },
                        !productListCategorySort[this.props.collectionName.toLowerCase()] &&
                            Object.keys(this.state.productSortedByCategory)
                                .map(function (key, index) {
                                if (!_this.state.productSortedByCategory[key] || key.toLowerCase() === 'marketing') {
                                    return null;
                                }
                                return (_this.renderCategory(_this.state.productSortedByCategory[key], key));
                            }),
                        __spreadArray([], __read(this.state.groupedBySeason.keys()), false).map(function (category) {
                            var seasons = _this.state.groupedBySeason.get(category);
                            if (seasons) {
                                return _this.renderCategoryBySeasonCodes(seasons, category);
                            }
                            return null;
                        }
                        // jobsForDate.map(job => (
                        //     <TruckJobComp job = { job } />
                        // ))
                        ),
                        this.state.productSortedByCategory['Marketing'] && this.renderCategory(this.state.productSortedByCategory['Marketing'], 'Marketing')),
                this.props.useInfiniteScroll &&
                    React.createElement(InfinityList, { elements: this.state.elements, onSticky: this.onSticky, onUnSticky: this.onUnSticky, handleOnProductClick: this.handleOnProductClick, lineDiscount: this.props.lineDiscount, isInBasket: this.isInBasket, lazyLoadMoloMaster: this.props.lazyLoadMoloMaster, loadItems: this.loadItems, hasMore: this.state.hasMore, getPrice: this.props.getPrice, showQuantity: this.props.showQuantity, showSoldQuantity: this.props.showSoldQuantity, showBarcode: this.props.showBarcode, handleShowStyleOrders: this.props.handleOnShowStyleOrdersClick, baseUrl: this.props.baseUrl, imageUrlForProduct: this.props.imageUrlForProduct, thumbnailRevision: this.props.thumbnailRevision, basketRevision: this.props.basketRevision, gridViewMode: this.state.gridViewMode })),
            !this.props.ignoreFilter &&
                React.createElement("div", { className: "filter-dropdown__toggler__row" },
                    React.createElement("div", { className: "filter-dropdown__toggler__wrapper" },
                        React.createElement("div", { className: "filter-dropdown__toggler" + (this.props.showFilter ? " open" : ""), onClick: function () { _this.props.onClickShowFilter && _this.props.onClickShowFilter(); } },
                            React.createElement("span", { className: "filter-dropdown__toggler__title desktop-only" }, !this.props.showFilter ? 'Show filter' : 'Hide filter'),
                            React.createElement(FilterIcon, null))),
                    this.props.showAgeSegmentQuickFilter &&
                        React.createElement("div", { className: "filter-dropdown__toggler__wrapper filter-dropdown__toggler__wrapper--age-segment" },
                            React.createElement("select", { id: "age-segment-quick-filter", "aria-label": "Age segment", className: 'filter-chip-select' +
                                    ((this.props.ageSegmentQuickFilter || 'all') !== 'all' ? ' is-active' : ''), value: this.props.ageSegmentQuickFilter || 'all', onChange: function (e) {
                                    var segment = e.target.value;
                                    _this.props.onAgeSegmentQuickFilterChange &&
                                        _this.props.onAgeSegmentQuickFilterChange(segment);
                                } },
                                React.createElement("option", { value: "all" }, "All"),
                                React.createElement("option", { value: "baby" }, "Baby"),
                                React.createElement("option", { value: "junior" }, "Junior"),
                                React.createElement("option", { value: "youth" }, "Youth"))))));
    };
    return ProductList;
}(Component));
export { ProductList };
//# sourceMappingURL=ProductList.js.map